// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".semi-overflow-list{display:flex;flex-wrap:nowrap;min-width:0}.semi-overflow-list-spacer{flex-shrink:1;width:1px}.semi-overflow-list-scroll-wrapper{display:flex;flex:1;flex-wrap:nowrap;overflow-x:scroll}.semi-rtl .semi-overflow-list,.semi-portal-rtl .semi-overflow-list{direction:rtl}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
